"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto p-4" };
const _hoisted_2 = { class: "text-xl sm:text-2xl mb-4 sm:my-5 sm:ml-5 font-bold uppercase text-center sm:text-left" };
const _hoisted_3 = { class: "bg-white p-5 mb-4" };
const _hoisted_4 = { class: "flex justify-between items-center uppercase font-bold text-base sm:text-xl border-b-1 border-gray pb-3" };
const _hoisted_5 = { class: "flex items-center gap-2 p-4" };
const _hoisted_6 = { class: "flex gap-2 items-center" };
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash text-xl" }, null, -1);
const _hoisted_8 = { class: "bg-white p-5 mb-4" };
const _hoisted_9 = { class: "flex justify-between items-center uppercase font-bold text-base sm:text-xl border-b-1 border-gray pb-3" };
const _hoisted_10 = { class: "flex flex-col gap-2 p-4" };
const _hoisted_11 = { class: "flex gap-2 items-center" };
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-info-circle text-blue text-xl" }, null, -1);
const _hoisted_13 = { class: "flex gap-2 items-center" };
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-info-circle text-blue text-xl" }, null, -1);
const _hoisted_15 = {
    key: 0,
    class: "flex flex-col gap-4 p-4"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "flex gap-2 items-center" };
const _hoisted_18 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash text-xl" }, null, -1);
const _hoisted_19 = { class: "flex flex-col sm:flex-row justify-center gap-3 sm:gap-5 p-3 sm:p-5" };
const _hoisted_20 = { class: "flex gap-2 items-center" };
const _hoisted_21 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-upload text-xl" }, null, -1);
const _hoisted_22 = { class: "flex gap-2 items-center" };
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-eye text-xl" }, null, -1);
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { key: 1 };
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const vue_router_1 = require("vue-router");
const customDesignStore_1 = require("../../stores/customDesign/customDesignStore");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomDesign',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const uploadedFile = (0, vue_3.ref)(null);
        const testDesignIsActive = (0, vue_3.ref)(false);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const isDefaultColor = (0, vue_3.computed)(() => {
            return (customDesignStore.currentColor || customDesignStore.marsoRed) === customDesignStore.marsoRed;
        });
        const handleFileChange = (event) => {
            const target = event.target;
            if (target.files && target.files[0]) {
                const file = target.files[0];
                uploadedFile.value = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    var _a, _b;
                    if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) {
                        if (file.type === "image/png") {
                            customDesignStore.filePath = (_b = e.target) === null || _b === void 0 ? void 0 : _b.result;
                        }
                    }
                };
                reader.readAsDataURL(file);
            }
        };
        const saveDesign = async () => {
            var _a;
            let request = {};
            try {
                if (uploadedFile.value && customDesignStore.currentColor) {
                    if (checkFileSizeAndType()) {
                        const base64String = await customDesignStore.readFileAsBase64(uploadedFile.value);
                        request = {
                            pageColor: customDesignStore.currentColor,
                            logo: {
                                name: uploadedFile.value.name,
                                base64: base64String
                            }
                        };
                    }
                }
                else if (uploadedFile.value) {
                    if (checkFileSizeAndType()) {
                        const base64String = await customDesignStore.readFileAsBase64(uploadedFile.value);
                        request = {
                            logo: {
                                name: uploadedFile.value.name,
                                base64: base64String
                            }
                        };
                    }
                }
                else {
                    request = {
                        pageColor: customDesignStore.currentColor,
                    };
                }
                await customDesignStore.saveDesign(router, request, (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.customer.id);
                toastStore.addToast({
                    message: (0, i18n_1.trans)("design_saved_successfully", "Design saved successfully!", "custom_design"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const testDesign = () => {
            if (!testDesignIsActive.value && currentUser.value) {
                // Design beállítása, de ne kérjük le újra az adatbázisból az adatokat.
                customDesignStore.setDesign(currentUser.value, false);
                testDesignIsActive.value = true;
                // A footer design is álljon át, de ne mentsük a localstorage-ba ezt a változót.
                customDesignStore.isCustomPriceViewActive = true;
            }
            else {
                // Design visszaállítása.
                customDesignStore.resetDesign();
                testDesignIsActive.value = false;
                // A footer design is álljon vissza az alapra.
                customDesignStore.isCustomPriceViewActive = false;
            }
        };
        const checkFileSizeAndType = () => {
            const maxFileSize = 500 * 1024;
            if (!uploadedFile.value)
                return;
            if (uploadedFile.value.type !== 'image/png') {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("incorrect_logo_format", "The logo is not in PNG format.", "custom_design"),
                    type: "danger",
                    timer: 5,
                });
                return false;
            }
            if (uploadedFile.value.size > maxFileSize) {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("logo_too_large", "The logo is too large.", "custom_design"),
                    type: "danger",
                    timer: 5,
                });
                return false;
            }
            return true;
        };
        const removeLogo = async () => {
            var _a;
            const request = { removeLogo: true };
            customDesignStore.filePath = "";
            uploadedFile.value = null;
            const fileInput = document.getElementById("logo-upload");
            if (fileInput) {
                fileInput.value = "";
            }
            try {
                await customDesignStore.removeDesign(router, request, (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.customer.id);
                toastStore.addToast({
                    message: (0, i18n_1.trans)("logo_removed_successfully", "Logo removed successfully!", "custom_design"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const removeColor = async () => {
            var _a;
            const request = { removePageColor: true };
            customDesignStore.currentColor = customDesignStore.marsoRed;
            try {
                await customDesignStore.removeDesign(router, request, (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.customer.id);
                toastStore.addToast({
                    message: (0, i18n_1.trans)("color_removed_successfully", "Color removed successfully!", "custom_design"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('custom_design', 'Custom design', 'custom_design')), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('select_color', 'Select color', 'custom_design')), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('current_color', 'Current color:', 'custom_design')), 1),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(customDesignStore).currentColor) = $event)),
                            type: "color"
                        }, null, 512), [
                            [vue_2.vModelText, (0, vue_2.unref)(customDesignStore).currentColor]
                        ])
                    ]),
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                        default: (0, vue_2.withCtx)(() => [
                            (!(0, vue_2.unref)(isDefaultColor))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn btn-rounded btn-secondary !text-sm sm:!text-base mx-4",
                                    onClick: removeColor
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                        _hoisted_7,
                                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("remove_color", "Remove color", "custom_design")), 1)
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        _: 1
                    })
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('select_logo', 'Select logo', 'custom_design')), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            _hoisted_12,
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('accepted_logo_format', 'Please upload the logo in .png format.', 'custom_design')), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            _hoisted_14,
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('accepted_logo_size', 'Maximum file size is 0.5 MB.', 'custom_design')), 1)
                        ]),
                        (0, vue_2.createElementVNode)("input", {
                            id: "logo-upload",
                            type: "file",
                            onChange: handleFileChange
                        }, null, 32)
                    ]),
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                        default: (0, vue_2.withCtx)(() => [
                            ((0, vue_2.unref)(customDesignStore).filePath)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('current_logo', 'Current logo:', 'custom_design')), 1),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("img", {
                                            class: "max-w-[150px] max-h-[30px]",
                                            src: (0, vue_2.unref)(customDesignStore).filePath,
                                            alt: "logo"
                                        }, null, 8, _hoisted_16)
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-secondary !text-sm sm:!text-base max-w-fit",
                                        onClick: removeLogo
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                            _hoisted_18,
                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("remove_logo", "Remove logo", "custom_design")), 1)
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        _: 1
                    })
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary !bg-green !border-green !text-sm sm:!text-base",
                        onClick: saveDesign
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_20, [
                            _hoisted_21,
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save_design", "Save design", "custom_design")), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        class: (0, vue_2.normalizeClass)([!testDesignIsActive.value ? '!bg-blue !text-white' : '!bg-white !text-blue', "btn btn-rounded btn-primary !border-2 !text-sm sm:!text-base"]),
                        onClick: testDesign
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                            _hoisted_23,
                            (!testDesignIsActive.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("test_design", "Test design", "custom_design")), 1))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("reset_design", "Reset design", "custom_design")), 1))
                        ])
                    ], 2)
                ])
            ]));
        };
    }
});
